export type FileTypeAccepted = 'text/html' | 'message/rfc822' | 'application/pdf' | 'image/png' | 'image/jpeg'

export type FileState = {
  id: string
  name: string
  type: FileTypeAccepted
  createOn: Date
  URL: string
}

export type AttachesTabState = {
  files: FileState[]
  ui: {
    loading: boolean
  }
}

export function isImage(type: FileTypeAccepted){
  return type === 'image/png' || type === 'image/jpeg'
}

export function isPDF(type: FileTypeAccepted){
  return type === 'application/pdf'
}

export function isHTML(type: FileTypeAccepted){
  return type === 'text/html'
}

export function isEmail(type: FileTypeAccepted){
  return type === 'message/rfc822'
}
